var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "LBL0003032" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && _vm.parentVendorCd
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBL0003033",
                              icon: "verified_user",
                            },
                            on: { btnClicked: _vm.changePortalId },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.parentVendorCd
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.resetUrl,
                              isSubmit: _vm.isReset,
                              param: _vm.data,
                              mappingType: "PUT",
                              label: "LBL0003034",
                              icon: "password",
                            },
                            on: {
                              beforeAction: _vm.resetPwd,
                              btnCallback: _vm.resetPwdCallback,
                            },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "LBLREG", icon: "add" },
                            on: { btnClicked: _vm.addVendor },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              disabled: !_vm.saveable,
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.data,
                              mappingType: _vm.saveType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveData,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        label: "LBL0003030",
                        name: "vendorName",
                      },
                      model: {
                        value: _vm.data.vendorName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorName", $$v)
                        },
                        expression: "data.vendorName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable:
                          _vm.editable && !_vm.updateMode && _vm.dataeditable,
                        label: "LBL0003035",
                        name: "vendorCd",
                      },
                      model: {
                        value: _vm.data.vendorCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorCd", $$v)
                        },
                        expression: "data.vendorCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        label: "LBL0003036",
                        name: "bizNo",
                        mask: "###-##-#####",
                      },
                      on: {
                        dataChange: (value) => {
                          _vm.data.portalId = _vm.$_.replace(value, /-/g, "")
                        },
                      },
                      model: {
                        value: _vm.data.bizNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "bizNo", $$v)
                        },
                        expression: "data.bizNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-select", {
                      attrs: {
                        codeGroupCd: "VENDOR_CLASS_CD",
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "vendorClassCd",
                        label: "LBL0003027",
                      },
                      model: {
                        value: _vm.data.vendorClassCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorClassCd", $$v)
                        },
                        expression: "data.vendorClassCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-select", {
                      attrs: {
                        codeGroupCd: "VENDOR_TYPE_CD",
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "vendorTypeCd",
                        label: "LBL0003028",
                      },
                      model: {
                        value: _vm.data.vendorTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "vendorTypeCd", $$v)
                        },
                        expression: "data.vendorTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "LBL0003037",
                        name: "representName",
                      },
                      model: {
                        value: _vm.data.representName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "representName", $$v)
                        },
                        expression: "data.representName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        phoneNumberCheck: true,
                        label: "LBL0003038",
                        name: "phoneNo",
                      },
                      model: {
                        value: _vm.data.phoneNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "phoneNo", $$v)
                        },
                        expression: "data.phoneNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "LBL0003039",
                        name: "email",
                      },
                      model: {
                        value: _vm.data.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "email", $$v)
                        },
                        expression: "data.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "LBL0003040",
                        name: "chargeName",
                      },
                      model: {
                        value: _vm.data.chargeName,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "chargeName", $$v)
                        },
                        expression: "data.chargeName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-8" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        label: "LBL0003041",
                        name: "address",
                      },
                      model: {
                        value: _vm.data.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "address", $$v)
                        },
                        expression: "data.address",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable && _vm.dataeditable,
                        isFlag: true,
                        label: "LBLUSEFLAG",
                        name: "useFlag",
                      },
                      model: {
                        value: _vm.data.useFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "useFlag", $$v)
                        },
                        expression: "data.useFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-multi-select", {
                      attrs: {
                        required: true,
                        editable: _vm.editable && _vm.dataeditable,
                        isArray: false,
                        codeGroupCd: "PLANT_CD",
                        itemText: "codeName",
                        itemValue: "code",
                        label: "LBL0003031",
                        name: "plantCds",
                      },
                      model: {
                        value: _vm.data.plantCds,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "plantCds", $$v)
                        },
                        expression: "data.plantCds",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "LBL0003042" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        isFlag: true,
                        label: "LBL0003043",
                        name: "portalConnFlag",
                      },
                      model: {
                        value: _vm.data.portalConnFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "portalConnFlag", $$v)
                        },
                        expression: "data.portalConnFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        readonly: "",
                        editable: _vm.editable,
                        label: "LBL0003044",
                        name: "portalId",
                      },
                      model: {
                        value: _vm.data.portalId,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "portalId", $$v)
                        },
                        expression: "data.portalId",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }